import { PokerRoom } from '../../model/enumeration/PokerRoom';
import { Player } from '../../model/Player';
import { PlayerPosition } from './Game.props';

const SHIFT = { 2: 1, 3: 0.5, 4: 1, 5: 0.5, 6: 1, 7: 1.5, 8: 1, 9: 1.5, 10: 1 };

const calculateAngleBetweenPlayerCenterAndTableCenter = (
  tableCenterX: number,
  tableCenterY: number,
  playerCenterX: number,
  playerCenterY: number,
): number => {
  const dx = tableCenterX - playerCenterX;
  const dy = tableCenterY - playerCenterY;

  const angleRadians = Math.atan2(dy, dx);

  // radians to degrees
  return Math.abs(angleRadians * (180 / Math.PI));
};

const calculateSift = (playerLength: number): number => {
  return SHIFT[playerLength];
};

export const calculatePlayerPositions = (
  tableElement: HTMLDivElement,
  players: (Player | null)[],
  isSingleTable: boolean,
  room: PokerRoom,
): PlayerPosition[] => {
  const tableWidth = tableElement.offsetWidth - 90;
  const tableHeight = tableElement.offsetHeight - 80;

  const tableCenterX = tableWidth / 2;
  const tableCenterY = tableHeight / 2;

  return players.map((player, index) => {
    const shift = room === PokerRoom.ClubGG ? calculateSift(players.length) : 0;
    const angle = (Math.PI * 2 * (index + shift)) / players.length;
    const playerX =
      tableWidth / 2 +
      Math.cos(angle - Math.PI / 2) * (tableWidth / 2 + 80) -
      80;
    const playerY =
      tableHeight / 2 +
      Math.sin(angle - Math.PI / 2) * (tableHeight / 2 + 50) -
      50;

    const playerCenterX = playerX + 230 / 2; //230 - player width
    const playerCenterY = playerY + 200 / 2; // 200 - player height

    const angleBetweenPlayerCenterAndTableCenter =
      calculateAngleBetweenPlayerCenterAndTableCenter(
        tableCenterX,
        tableCenterY,
        playerCenterX,
        playerCenterY,
      );

    const tableSidePlayersDistanceCoefficient =
      isSingleTable && window.innerWidth > 1200 && players.length < 7
        ? 0.34
        : 0.4;

    const tableTopAndBottomPlayersDistanceCoefficient =
      isSingleTable && window.innerWidth > 1200 && window.innerWidth < 1368
        ? 0.6
        : 0.55;

    const distanceCoefficient =
      (angleBetweenPlayerCenterAndTableCenter <= 142 &&
        angleBetweenPlayerCenterAndTableCenter >= 90) ||
      (players.length === 5 &&
        angleBetweenPlayerCenterAndTableCenter > 40 &&
        angleBetweenPlayerCenterAndTableCenter < 57) ||
      ((players.length === 7 || players.length === 9) &&
        angleBetweenPlayerCenterAndTableCenter > 55 &&
        angleBetweenPlayerCenterAndTableCenter < 76)
        ? tableTopAndBottomPlayersDistanceCoefficient
        : tableSidePlayersDistanceCoefficient;

    const betX =
      playerCenterX + (tableCenterX - playerCenterX) * distanceCoefficient;
    const betY =
      playerCenterY + (tableCenterY - playerCenterY) * distanceCoefficient - 10;

    return {
      player: player,
      tablePosition: { playerX: playerX, playerY: playerY },
      betPosition: { betX, betY },
    } as PlayerPosition;
  });
};

export const formatNumber = (value: number): string => {
  return value
    ? value.toLocaleString('en-US', {
        minimumFractionDigits: value % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2,
        useGrouping: false,
      })
    : '0';
};

export const trimNumber = (value: number): number => {
  return parseFloat(formatNumber(value));
};
